// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e7fb625f","879":"93f17234"}[chunkId] + ".chunk.js";
};